// src/hooks/useLogout.js
import { useNavigate } from 'react-router-dom';
import authApi from '../api/authApi';
import { useDispatch, useSelector } from 'react-redux';
import { selectUserId } from '../components/Login/loginSlice';
import { clearFeatures } from '../features/featuresSlice';

export const useLogout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const deviceId = localStorage.getItem('deviceId');
  const userId = useSelector(selectUserId);

  const logout = async () => {
    try {
      if (!userId || !deviceId) return;
      await authApi.logout(userId, deviceId);
      localStorage.clear();
      // Очищаем features при логауте
      dispatch(clearFeatures());
      navigate('/login');
    } catch (error) {
      console.error('Ошибка при выходе:', error);
    }
  };

  return { logout };
};
